import React from 'react';

import Button from '../../UI/Button/Button';
import Input from '../../UI/Input/Input';

import langStrings from '../../../lang/languageStrings.json';

import styles from '../PTAdmin/PTManagement.module.css';

const editAppConfigForm = props => {
  return (
    <div className={styles.Box}>
      <h2>{langStrings[props.language]['nav_app_config']}</h2>
      <p>{langStrings[props.language]['edit_app_config_desc']}</p>

      <Input
        language={props.language}
        inputtype='textarea'
        label={langStrings[props.language].news_box_de}
        elementConfig={{
          id: 'news_de',
          type: 'text',
          value: props.appConfig.news_de,
          maxLength: 250,
          onChange: props.inputHandler
        }}/>

      <Input
        language={props.language}
        inputtype='textarea'
        label={langStrings[props.language].news_box_en}
        elementConfig={{
          id: 'news_en',
          type: 'text',
          value: props.appConfig.news_en,
          maxLength: 250,
          onChange: props.inputHandler
        }}/>

      <Button buttonHandler={props.submissionHandler}>
        {langStrings[props.language].submit}
      </Button>
    </div>
  )
}

export default editAppConfigForm;
